import { EmptyStates, Stack } from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';

export function EmptyStateForError() {
  const { t } = useTranslation();

  return (
    <Stack justify="center" align="center" w="100%" h={320}>
      <EmptyStates
        image="ERROR"
        title={t('문제가 발생했어요')}
        body={t('새로고침 후 문제가 지속되면 지원팀에 문의해 주세요.')}
      />
    </Stack>
  );
}
